<div class="project-imgContainer imgContainer">
  <figure class="imgContainer-figure">
    <img class="imgContainer-img" [src]="imageSrc" alt="img11"/>
    <figcaption class="imgContainer-figcaption">
      <div class="imgContainer-fade"></div>
      <button class="imgContainer-text btn btn__hovered">
        {{buttonText}}
      </button>
    </figcaption>
  </figure>
</div>


